import { StrategicAxesRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: StrategicAxesRepository): Interactor {
  return ({ project, strategicAxis, projectStrategicAxis }) =>
    present(
      repository
        .saveProjectStrategicAxis(project, strategicAxis, projectStrategicAxis)
        .then((projectStrategicAxis) => ({
          project,
          strategicAxis,
          projectStrategicAxis,
        }))
        .catch(() =>
          Promise.reject({
            project,
            strategicAxis,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
